import ky from 'ky-universal';

import extendOrInitSession from './extendOrInitSession';
import getGeneralFields from './getGeneralFields';

import {
  TRACKING_EVENT__PLAY_PLAYER,
  TRACKING_OPERATION__SYSCTL,
  TRACKING_OPERATION__CLICK,
  TRACKING_API_ENDPOINT,
} from '../../../constants';

/**
 * 傳送 play_player 事件：
 * 先延長或建立新的 session，
 * 將 session ID 及 metadata (影片播放資訊) 傳送到後端。
 *
 * @param {object} [options]
 * @param {string} [options.drama_id]
 * @param {string} [options.video_id] video index | 花絮id | 預告id
 * @param {string} [options.video_type] episode(正片) | behind_the_scenes(花絮) | trailers(預告)
 * @param {number} [options.play_start_time] 影片從第幾秒開始播放
 * @param {boolean} [options.autoplay]
 */
async function sendPlayPlayerEvent(options = {}) {
  await extendOrInitSession();

  /** @see {@link https://docs.google.com/spreadsheets/d/1OMhlNt-5jTx0Z-LNWI3O_3EbijNopKBE_SdsHPU3Jmw/edit#gid=1146550572} */
  const payload = {
    ...getGeneralFields(),
    event: TRACKING_EVENT__PLAY_PLAYER,
    op: options.autoplay ? TRACKING_OPERATION__SYSCTL : TRACKING_OPERATION__CLICK,
    op_meta: {
      // entrypoint: undefined,
      drama_id: options.drama_id,
      video_id: options.video_id,
      video_type: options.video_type,
      play_start_time: options.play_start_time,
    },
  };

  await ky.post(TRACKING_API_ENDPOINT, { json: payload, throwHttpErrors: false });
}

import schedulePendingTasks from '../schedulePendingTasks';

export default (...args) => schedulePendingTasks(
  () => sendPlayPlayerEvent(...args)
);
